module.exports = __webpack_public_path__ + "img/logo.bbee844c.svg";